// reactaStaffRole.js — extraido de src/Layout/layout.jsx (era uma funcao
// local nao exportada) para que a Presenca Operacional (Missao Persistencia/
// Detach/Videowall) possa determinar `isReactaWebmaster` no MESMO ponto de
// montagem global (App.jsx) sem duplicar a logica de normalizacao de papel
// e correr o risco de ela divergir da usada pelo Layout (Secao de
// "single source of truth" do Canon).
//
// Console Webmaster (chaves/modelos de IA, laboratorio cognitivo, integrador,
// logs, acesso) e exclusivo de funcionarios da propria Reacta — webmaster e
// reacta_master, nunca papeis institucionais (institutional_owner,
// super_admin, tenant_admin, simulation_manager), que pertencem a outras
// instituicoes clientes, nao a equipe Reacta. Mesmo alias
// responsavel_tecnico->webmaster ja usado em IntelligenceOfficer.jsx e
// rooms/roomsService.js.
export function isReactaWebmasterStaff(roleValue) {
    const normalizedRole = String(roleValue || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[\s-]+/g, '_');
    const role = ({ responsavel_tecnico: 'webmaster' })[normalizedRole] || normalizedRole;
    return role === 'webmaster' || role === 'reacta_master';
}

// canUseManagerChat — mesma extracao/motivo de isReactaWebmasterStaff acima
// (Missao 7A, "CONSOLE LCARS DE PRESENCA OPERACIONAL", Secao 11-13): era uma
// funcao local nao exportada em src/Layout/layout.jsx, usada la para decidir
// se o Chat de Gestores aparece. A Missao 7A reusa o MESMO boolean, sem
// nenhuma autoridade nova, para o indicador visual discreto de funcao de
// gestao/comando na area de identidade do usuario — extrair para ca e o que
// torna essa reutilizacao testavel sem duplicar a normalizacao de papel
// (este repositorio nao tem jsdom/testing-library; funcoes puras extraidas
// sao a unica forma de testar logica que hoje vive dentro de um componente
// React). O local de chamada em layout.jsx (`canUseManagerChat(authoritativeRole)`)
// permanece textualmente identico — apenas a definicao muda de local para
// import — porque test/cis/navigationIntegration.test.js verifica essa
// string literal no codigo-fonte do arquivo.
export function canUseManagerChat(roleValue) {
    const normalizedRole = String(roleValue || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[\s-]+/g, '_');
    const role = ({
        responsavel_tecnico: 'webmaster',
        gestor_institucional: 'institutional_owner',
        comandante_do_incidente: 'incident_commander',
        comandante_de_incidente: 'incident_commander',
        comandante_de_operacoes: 'operations_commander',
        comandante_operacoes: 'operations_commander',
        chefe_de_operacoes: 'operations_chief',
        gestor_de_logistica: 'logistics_manager',
        comandante_de_logistica: 'logistics_manager',
        logistica: 'logistics',
        oficial_de_ligacao: 'liaison_officer',
        comunicacoes: 'communications',
    })[normalizedRole] || normalizedRole;
    return new Set([
        'webmaster', 'reacta_master', 'super_admin', 'institutional_owner', 'tenant_admin',
        'simulation_manager', 'manager', 'incident_commander', 'commander', 'operations_chief',
        'operation_commander', 'operations_commander', 'logistics', 'logistics_manager', 'safety',
        'safety_manager', 'communications', 'communications_manager', 'finance_admin_manager',
        'liaison', 'liaison_officer',
    ]).has(role);
}

export default { isReactaWebmasterStaff, canUseManagerChat };
